import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.332 8.5c0 1.092.283 1.46.85 2.197 1.131 1.47 3.029 3.136 5.817 3.136s4.685-1.667 5.816-3.136c.567-.737.85-1.105.85-2.198s-.283-1.46-.85-2.197C12.685 4.832 10.787 3.166 8 3.166S3.313 4.832 2.182 6.302c-.567.736-.85 1.104-.85 2.197",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.5 8.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m1 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }